import React from 'react';

import { Typography } from '@material-ui/core/';
import useStyles from './styles';

const FormErrorMessage = ({ errorMessage }) => {
  const { error } = useStyles();
  return (
    <>
      {errorMessage && (
        <Typography variant="body2" className={error}>
          Error: {errorMessage}
        </Typography>
      )}
    </>
  );
};

export default FormErrorMessage;
